import React, { useRef, useEffect } from "react";
import { ManualEditor } from "components/inputs/ManualEditor";
import { Descendant } from "slate";
import { useManualContext } from "../context/ManualContext";

export const ChapterEditorV2: React.FC = () => {
  const { state, updateChapter } = useManualContext();
  const saveTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const selectedChapter = state.selectedChapterId
    ? state.chapters[state.selectedChapterId]
    : null;

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
    };
  }, []);

  const handleChange = (content: Descendant[], hasChanged: boolean) => {
    if (!selectedChapter || !hasChanged) return;

    // Trigger debounced update on change (200ms)
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    saveTimeoutRef.current = setTimeout(() => {
      updateChapter(selectedChapter.id, content);
    }, 200);
  };

  if (!selectedChapter) {
    return (
      <div className="w-3/4 flex flex-col items-center justify-center overflow-y-scroll bg-gray-50 rounded-lg">
        <div className="text-center">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-gray-900">
            No chapter selected
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Select a chapter from the list to start editing
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-3/4 flex flex-col overflow-y-scroll">
      <ManualEditor
        label={`Editing: ${selectedChapter.title}`}
        onChange={handleChange}
        defaultValue={selectedChapter.content}
        key={selectedChapter.id} // Force re-render when selection changes
      />
    </div>
  );
};
